export default "__VITE_PUBLIC_ASSET__7bd5e28b__"